import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import { fetchApiRoot } from "./api";
import TopBar from './TopBar/index';
import { getPlayer, reloadPlayer } from "./player";
import useInterval from "react-useinterval";
import LeftSidebar from './LeftSidebar';
import "./translations/i18n";
import { useTranslation } from "react-i18next";
import Footer from './Footer';
import i18n from "i18next";
// Replaced iframe-resizer-react with a native <iframe>
import Affiliate from './Affiliate/affiliate';
import { Typography } from '@mui/material';
import Home from './Terminal/Home';

const POOLX_MESSAGE_SOURCE = 'poolx_game_client';

const GameArea = ({ frameLang, frameTheme, frameThemeMode, navigationKey, navigationId }) => {
  const player = useSelector(getPlayer);
  const dispatch = useDispatch();
  const { t } = useTranslation();


  const iframeRef = useRef(null);

  // Handle messages from the iframe: resize, scroll_to_top, reload_client
  useEffect(() => {
    let rafId = null;

    const applySize = (width, height, units = 'px') => {
      const el = iframeRef.current;
      if (!el) return;
      // Use requestAnimationFrame to avoid layout thrashing
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        if (width) {
          el.style.width = `${width}${units}`;
        }
        if (height) {
          el.style.height = `${height}${units}`;
        }
        rafId = null;
      });
    };

    const parseData = (raw) => {
      if (!raw) return null;
      if (typeof raw === 'string') {
        try { return JSON.parse(raw); } catch (e) { return raw; }
      }
      return raw;
    };

    const onMessage = (event) => {
      const data = parseData(event.data);

      // Extended format (from operatorAdviceContentResize with extended format)
      if (data && data.source === POOLX_MESSAGE_SOURCE && data.message_type === 'resize_content') {
        const payload = data.payload || {};
        const w = payload.width;
        const h = payload.height;
        const units = payload.units || 'px';
        applySize(w, h, units);
        return;
      }

      // Legacy/simple format: { type: 'content_resize', width, height, units }
      if (data && data.type === 'content_resize') {
        const w = data.width;
        const h = data.height;
        const units = data.units || 'px';
        applySize(w, h, units);
        return;
      }

      // Other control messages (scroll / reload)
      // legacy simple strings
      if (data === 'scroll_to_top' || (data && data.message_type === 'scroll_to_top')) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        return;
      }
      if (data === 'reload_client' || (data && data.message_type === 'reload_client')) {
        // eslint-disable-next-line no-restricted-globals
        location.replace(location.href);
        return;
      }
    };

    window.addEventListener('message', onMessage, false);
    return () => {
      window.removeEventListener('message', onMessage, false);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);


  // Poll wallet when game is open
  useInterval(() => {
    dispatch(reloadPlayer());
  }, player ? 5000 : null);

  if (player) {
    let navigationParams = "";

    if (navigationKey && navigationId) {
      navigationParams = `&navigationKey=${navigationKey}&navigationId=${navigationId}`;
    }

    const themeModeParam = frameThemeMode ? `&themeMode=${encodeURIComponent(frameThemeMode)}` : "";

    const gameUrl = `${process.env["REACT_APP_GAME_URL"]}?operatorId=MOCKOP&operatorPlayerId=${player.id}&operatorToken=${player.token}&lang=${frameLang}&theme=${frameTheme}${themeModeParam}${navigationParams}`;

    return (
      <iframe
        ref={iframeRef}
        title="game"
        className={'max-width'}
        scrolling="no"
        frameBorder="0"
        src={gameUrl}
        allow="clipboard-read; clipboard-write; web-share"
        style={{ width: '100%', height: '100vh', border: 0 }}
      />
    );
  } else {
    return (
      <div className="logged-out-div">
        <Typography sx={{ marginTop: '2rem' }} variant={'h1'}>{t("log_in_to_play")}</Typography>
      </div>
    );
  }
}

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchApiRoot());
  });

  const [showMenu, setShowMenu] = useState(window.screen.width >= 1212);
  const [showAffiliate, setShowAffiliate] = useState(false);

  const searchParams = new URLSearchParams(window.location.search);
  const lang = searchParams.get('lang') ? searchParams.get('lang') : i18n.languages[0];
  const theme = searchParams.get('theme') ? searchParams.get('theme') : 'green';
  const themeMode = searchParams.get('themeMode') || '';
  const navigationKey = searchParams.get('navigationKey') || undefined;
  const navigationId = searchParams.get('navigationId') || undefined;

  i18n.changeLanguage(lang);

  return (
    <Router>
      <Switch>
        <Route path={"/terminal"}>
          <Home />
        </Route>
        <Route path={"/"}>
          {showAffiliate === true ? <Affiliate /> :
            <div className="wrapper">
              <TopBar searchParams={searchParams} selectedLanguage={lang} setShowMenu={setShowMenu} showMenu={showMenu} selectedTheme={theme} />
              <div className="side-bars">
                <div className="game-flex-div">
                  {showMenu ? <LeftSidebar /> : <div />}
                  <GameArea frameLang={lang} frameTheme={theme} frameThemeMode={themeMode} navigationKey={navigationKey} navigationId={navigationId} />
                </div>
              </div>
              <Footer searchParams={searchParams} selectedLanguage={lang} selectedTheme={theme} selectedThemeMode={themeMode} setShowAffiliate={setShowAffiliate} />
            </div>
          }
        </Route>
      </Switch>
    </Router >);
}

export default App;
